import { useCallback, useReducer } from 'react'
import { deserialize, serialize } from '../utils/JsonSerializer'

const defaultStats = {
  quickNameReview: { prev: 0, cur: 0 },
  fullNameReview: { prev: 0, cur: 0 },
  familyReview: { prev: 0, cur: 0 },
  verifyPlaces: { prev: 0, cur: 0 },
}

const key = 'give:user-session-stats'

const getInitialState = () => {
  if (typeof window === 'undefined') return defaultStats
  const stored = window.sessionStorage.getItem(key)
  return stored ? deserialize(stored) : defaultStats
}

const reducer = (state, action) => {
  let newState
  switch (action.type) {
    case 'update':
      newState = { ...state, ...action.payload }
      break
    case 'delete':
      newState = defaultStats
      if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem(key)
      }
      break
    default:
      return state
  }

  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(key, serialize(newState))
  }
  return newState
}

/**
 * Hook to get and set the user's session stats
 * @returns {object} - The user's session stats and functions to update and delete the stats
 */
export default function useSessionStats() {
  const [stats, dispatch] = useReducer(reducer, getInitialState())

  const updateStats = useCallback((updatedStats = {}) => {
    dispatch({ type: 'update', payload: updatedStats })
  }, [])

  const deleteStats = useCallback(() => {
    dispatch({ type: 'delete' })
  }, [])

  return { stats, deleteStats, updateStats }
}
